<div  role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Meeting Details</h2>
    </div>
    <div class="modal-body">
      <form #meetingForm="ngForm">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="meetingDate">Meeting Date</label>
                  <input class="form-control" type="date" name="meetingDate" id="meetingDate" placeholder="Meeting date" ngModel required>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="meetingTime">Meeting Time</label>
                  <input class="form-control" type="time" name="meetingTime" id="meetingTime" placeholder="Meeting Time" ngModel required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                  <div class="form-group">
                    <label for="meetingPlace">Meeting Place</label>
                    <input class="form-control" name="meetingPlace" id="meetingPlace"  placeholder="Meeting Place" ngModel required>
                </div>
              </div>
              <div class="col-md-6">
                  <div class="form-group">
                    <label for="assignedTo">Assigned To</label>
                    <select name="assignedTo" id="assignedTo" class="form-control" ngModel>
                      <option *ngFor="let user of users" value="{{user.id}}">{{user.fullname}}</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="form-group">
                <label for="notes">Notes</label>
                <textarea class="form-control" name="notes" id="notes" rows="5" placeholder="Meeting date and time" ngModel></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="saveMeeting(meetingForm.value)" [disabled]="meetingForm.invalid">Save Meeting</button>
        <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
    </div>
  </div>
</div>